import type { CourseLectureId } from '../types/course-lecture-interface'
import type { CourseQuizId } from '../types/course-quiz-interface'
import type { CourseStepEnum } from '../types/course-step-type'

type GetCoursePageUrlArgs = { coursePath: string } & (
  | {
      id: CourseLectureId
      type: CourseStepEnum.assignment
    }
  | {
      id: CourseLectureId
      type: CourseStepEnum.lecture
    }
  | {
      id: CourseQuizId
      type: CourseStepEnum.quiz
    }
  | {
      id?: never
      type?: never
    }
)

export const getCoursePageQuery = (args: GetCoursePageUrlArgs): string => {
  return `/school/course/${args.coursePath}/${args.type}/${args.id}`
}
